import { useState } from "react";

const DEFAULT_ROWS_PER_PAGE = 10;

export const useConsultationViewState = () => {
  const [activeConsultation, setActiveConsultation] = useState(undefined);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
  const [search, setSearch] = useState("");

  const openAdd = () => {
    setActiveConsultation(undefined);
    setIsFormOpen(true);
  };

  const openEdit = (consultation) => {
    setActiveConsultation(consultation);
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
    setActiveConsultation(undefined);
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const handleRowsChange = (value) => {
    setRowsPerPage(value);
    setPage(1);
  };

  return {
    activeConsultation,
    isFormOpen,
    page,
    setPage,
    rowsPerPage,
    search,
    openAdd,
    openEdit,
    closeForm,
    handleSearchChange,
    handleRowsChange,
  };
};
